import { defineComponent as o, createBlock as t, openBlock as r, unref as a, withCtx as n, renderSlot as l, resolveDynamicComponent as c, normalizeClass as m } from "vue";
import s from "./highrise353.mjs";
import "./highrise64.mjs";
import f from "./highrise78.mjs";
/* empty css            */
const g = o({
  name: "HLFormItemTooltip",
  inheritAttrs: !1
}), S = /* @__PURE__ */ o({
  ...g,
  props: {
    trigger: {
      type: String,
      default: "hover"
    },
    placement: {
      type: String,
      default: void 0
    },
    icon: {
      type: Function,
      default: s
    },
    iconClass: String
  },
  setup(e) {
    return (i, u) => (r(), t(a(f), {
      placement: e.placement,
      trigger: e.trigger
    }, {
      trigger: n(() => [
        (r(), t(c(e.icon), {
          class: m(e.iconClass ? e.iconClass : "w-4 h-4 text-gray-500")
        }, null, 8, ["class"]))
      ]),
      default: n(() => [
        l(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["placement", "trigger"]));
  }
});
export {
  S as default
};
